import { render } from "./EmployeeTrainingForm.vue?vue&type=template&id=15f37fb7"
import script from "./EmployeeTrainingForm.vue?vue&type=script&lang=js"
export * from "./EmployeeTrainingForm.vue?vue&type=script&lang=js"

import exportComponent from "/var/www/html/amatra-frontend-dev/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__